export default "__VITE_ASSET__Ygywul03__"